import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/sales-invoice-item-reports/:invoiceId/export-pdf`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const exportSinglePDF = {
  post: apiPathFunc(pathBase),
};
